import superagent from "superagent";
import Cookies from "universal-cookie";
import { base_url } from "../../utils/constants";
import { GET_NOTIFICATIONS, REMOVE_NOTIFICATION } from "./constants";

const cookie = new Cookies();

function getRequest(url, data, dispatch, type = null, cookie_option = null) {
  return superagent
    .get(`${base_url}${url}`)
    .query(data)
    .set("accept", "application/json")
    .set("Authorization", cookie.get("user_token"))
    .end((_err, res) => {
      if (res) {
        if (type !== null) {
          dispatch({ type, payload: res.body });
        }
        if (cookie_option === "save") {
          const token = res.body.data.access_token;
          cookie.set("user_token", token);
        }
        if (res.body.reload) {
          window.location.reload();
        }
      }
    });
}

export const getNotifications = (showAll) => (dispatch) => {
  const data = showAll ? { request_type: "show_all" } : "";
  getRequest("admin/user-notification-list", data, dispatch, GET_NOTIFICATIONS);
};

export const readNotification = (id, showAll, dispatch) => {
  superagent
    .post(`${base_url}admin/notification-read`)
    .set("Content-Type", "application/json")
    .set("Authorization", cookie.get("user_token"))
    .send(JSON.stringify({ request_type: "", ids: id }))
    .end(() => {
      dispatch(getNotifications(showAll || null));
    });
};

export const readAllNotification = (ids, showAll, dispatch) => {
  superagent
    .post(`${base_url}admin/notification-read`)
    .set("Content-Type", "application/json")
    .set("Authorization", cookie.get("user_token"))
    .send(JSON.stringify({ request_type: "mark_all", ids: ids.join(",") }))
    .end(() => {
      dispatch(getNotifications(showAll || null));
    });
};

export const removeNotification = (id, showAll, dispatch) => {
  dispatch({ type: REMOVE_NOTIFICATION, payload: id });
  superagent
    .post(`${base_url}admin/notification-close`)
    .set("Content-Type", "application/json")
    .set("Authorization", cookie.get("user_token"))
    .send(JSON.stringify({ id: `${id}` }))
    .end(() => {
      dispatch(getNotifications(showAll || null));
    });
};
